import { Box, Slider, styled, Tooltip, Typography } from "@mui/material";
import MuiInput from "@mui/material/Input";
import { useEffect, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";
import Grid from "@mui/material/Grid2";

function valuetext(value) {
  return `${value}`;
}

const Input = styled(MuiInput)`
  width: 60px !important;
`;

const DvigubaSlankjuoste = ({
  min,
  max,
  label,
  numatytoji,
  marksBigScreen,
  marksSmallScreen,
  zingsnis,
  changeValue,
  pavadinimas,
  disableSwap,
  minSkirtumas,
  smaller = false,
  toolTipPaaiskinimas = null,
}) => {
  const [value, setValue] = useState(numatytoji);
  const [inputValue, setInputValue] = useState(numatytoji);
  const [marks, setMarks] = useState(marksBigScreen);

  // sinchronizuoja busenas
  useEffect(() => {
    setValue(numatytoji);
    setInputValue(numatytoji);
  }, [numatytoji]);

  useEffect(() => {
    const updateLegendPosition = () => {
      if (window.innerWidth < 650) {
        setMarks(marksSmallScreen);
      } else {
        setMarks(marksBigScreen);
      }
    };

    updateLegendPosition();
    window.addEventListener("resize", updateLegendPosition);

    return () => window.removeEventListener("resize", updateLegendPosition);
  }, []);

  // debouncas
  const debouncedSliderValue = useDebounce(value, 500);

  const debouncedInputValue = useDebounce(inputValue, 500);

  // atnaujina tevo komponento reiksme
  useEffect(() => {
    changeValue(debouncedSliderValue);
  }, [debouncedSliderValue, changeValue]);

  useEffect(() => {
    if (debouncedInputValue !== value) {
      setValue(debouncedInputValue);
    }
  }, [debouncedInputValue]);

  const handleInputChange = (index, event) => {
    const newInputValue = [...inputValue];
    const parsedValue = event.target.value === "" ? "" : Number(event.target.value);

    newInputValue[index] = parsedValue;
    setInputValue(newInputValue);
  };

  const handleSliderChange = (event, newValue, activeThumb) => {
    const [newLower, newHigher] = newValue;

    // uztikrina ar yra minimalus skirtumas tarp slanksteliu
    if (activeThumb === 0) {
      // zemesne reiksme
      const adjustedValue = [Math.min(newLower, value[1] - minSkirtumas), value[1]];
      setValue(adjustedValue);
      setInputValue(adjustedValue);
    } else {
      // aukstesne reiksme
      const adjustedValue = [value[0], Math.max(newHigher, value[0] + minSkirtumas)];
      setValue(adjustedValue);
      setInputValue(adjustedValue);
    }
  };

  const handleInputBlur = (index) => {
    const currentValue = inputValue[index];
    let newValue = typeof currentValue === "number" ? currentValue : min;

    newValue = Math.max(min, Math.min(max, newValue));

    if (index === 0) {
      newValue = Math.min(newValue, value[1] - minSkirtumas);
    } else {
      newValue = Math.max(newValue, value[0] + minSkirtumas);
    }

    const newValues = [...value];
    newValues[index] = newValue;

    setValue(newValues);
    setInputValue(newValues);
  };

  const handleInputKeyDown = (index, event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();

      const currentValue = inputValue[index];
      const step = zingsnis || 1;

      let newValue = currentValue;
      if (event.key === "ArrowUp") {
        newValue = Math.min(max, currentValue + step);
      } else if (event.key === "ArrowDown") {
        newValue = Math.max(min, currentValue - step);
      }

      if (index === 0) {
        newValue = Math.min(newValue, value[1] - (minSkirtumas || 0));
      } else {
        newValue = Math.max(newValue, value[0] + (minSkirtumas || 0));
      }

      const newValues = [...value];
      newValues[index] = newValue;

      setValue(newValues);
      setInputValue(newValues);
    }
  };

  const inputSizes = !smaller
    ? { xs: 8, sm: 8, md: 3, lg: 3, xl: 2 }
    : { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 };

  const inputOrder = !smaller
    ? { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }
    : { lxs: 1, sm: 1, md: 1, lg: 1, xl: 1 };
  const inputOrder2 = !smaller
    ? { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 }
    : { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 };

  const sliderSizes = !smaller
    ? { xs: "grow", sm: "grow", md: 10, lg: 10, xl: 12 }
    : { xs: "grow", sm: "grow", md: "grow", lg: "grow", xl: "grow" };
  const sliderOrder = !smaller
    ? { xs: 3, sm: 3, md: 2, lg: 2, xl: 2 }
    : { xs: 3, sm: 3, md: 3, lg: 3, xl: 3 };

  return (
    <Box width={"100%"}>
      <Typography>{pavadinimas}</Typography>
      <Grid container columns={16} spacing={1}>
        <Grid size={inputSizes} order={inputOrder}>
          <Input
            value={inputValue[0]}
            size="small"
            onChange={(e) => handleInputChange(0, e)}
            onBlur={() => handleInputBlur(0)}
            onKeyDown={(e) => handleInputKeyDown(0, e)}
            inputProps={{
              step: zingsnis,
              min: min,
              max: max,
              type: "number",
            }}
          />
        </Grid>

        <Grid size={inputSizes} order={inputOrder2} sx={{ textAlign: "right" }}>
          <Input
            value={inputValue[1]}
            size="small"
            onChange={(e) => handleInputChange(1, e)}
            onBlur={() => handleInputBlur(1)}
            onKeyDown={(e) => handleInputKeyDown(1, e)}
            inputProps={{
              step: zingsnis,
              min: min,
              max: max,
              type: "number",
            }}
          />
        </Grid>
        <Grid size={sliderSizes} order={sliderOrder}>
          {toolTipPaaiskinimas ? (
            <Tooltip title={toolTipPaaiskinimas} arrow>
              <Slider
                value={value}
                onChange={handleSliderChange}
                valueLabelDisplay="auto"
                getAriaValueText={valuetext}
                getAriaLabel={() => label}
                min={min}
                max={max}
                marks={marks}
                step={zingsnis}
                disableSwap={disableSwap}
              />
            </Tooltip>
          ) : (
            <Slider
              value={value}
              onChange={handleSliderChange}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              getAriaLabel={() => label}
              min={min}
              max={max}
              marks={marks}
              step={zingsnis}
              disableSwap={disableSwap}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default DvigubaSlankjuoste;
